/**
 * 设置页面路由
 */
export default [
  {
    path: '/opinion',
    component: '@/pages/opinion/layouts/index',
    routes: [
      {
        path: './AITaskCenter',
        routes: [
          {
            path: '.',
            component: '@/pages/opinion/pages/AITaskCenter/index',
          },
          {
            path: './Unsubscribe',
            component: '@/pages/opinion/pages/AITaskCenter/Unsubscribe/index',
          },
        ],
      },
      {
        path: './download',
        component:
          '@/pages/opinion/components/DownloadCommon/download-page/index',
      },
      {
        path: './TrendingPublications',
        component: '@/pages/opinion/pages/Overview/TrendingPublications/index',
      },
      {
        path: './MonitorScope',
        component: '@/pages/opinion/pages/MonitorScope/index',
      },
      {
        path: './NewDownload',
        component: '@/pages/opinion/pages/download/index',
      },
      {
        path: './Overview',
        routes: [
          {
            path: '.',
            component: '@/pages/opinion/pages/Performance/index',
          },
          {
            path: './KeyOpinions',
            component: '@/pages/opinion/pages/Overview/KeyOpinions/index',
          },
          {
            path: './KeyMetrics',
            component: '@/pages/opinion/pages/Overview/KeyMetrics/index',
          },
          {
            path: './KeyMetrics/EventDetails',
            component:
              '@/pages/opinion/pages/Overview/KeyMetrics/EventDetails/index',
          },
          {
            path: './CompareKeyMetrics',
            component: '@/pages/opinion/pages/Overview/CompareKeyMetrics/index',
          },
          {
            path: './TrendingPublications',
            component:
              '@/pages/opinion/pages/Overview/TrendingPublications/index',
          },
          {
            path: './Nikke',
            component: '@/pages/opinion/pages/NIKKE',
          },
          {
            path: './MarketPopularityRanking',
            component:
              '@/pages/opinion/pages/Compare/ChannelShareRanking/index',
          },
          {
            path: './RealtimeOpinions',
            component: '@/pages/opinion/pages/Overview/RealtimeOpinions/index',
          },
        ],
      },
      {
        path: './Summary',
        routes: [
          {
            path: './HotEvent',
            component: '@/pages/opinion/pages/Summary/SummaryHotEvent',
          },
          {
            path: './TopicTracking',
            component: '@/pages/opinion/pages/Summary/TopicTracking',
          },
          {
            path: './Excel',
            component: '@/pages/opinion/pages/Summary/TopicTrackingExcel',
          },
        ],
      },
      {
        path: './EventDetails',
        component: '@/pages/opinion/pages/EventDetails/index',
      },
      {
        path: './AIAnalysisHub',
        routes: [
          {
            path: './CustomAISummary',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/CustomAISummary/index',
          },
          {
            path: './CustomAISummary/preview/:id',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/CustomAISummary/pages/PreviewSummary/index',
          },
          {
            path: './KeywordAnalysis/preview/:id',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/PreviewAnalysis',
          },
          {
            path: './URLAnalysis/preview/:id',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/PreviewAnalysis',
          },
          {
            path: './KeywordAnalysis',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/KeywordAnalysis',
          },
          {
            path: './AITopicAnalysis',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/AITopicAnalysis',
          },
          {
            path: './URLAnalysis',
            component:
              '@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/URLAnalysis',
          },
          {
            path: './AIInsightsReport',
            component: '@/pages/opinion/pages/AIAnalysisHub/AIInsightsReport',
          },
        ],
      },
      {
        path: './News',
        component: '@/pages/opinion/pages/news/index',
      },
      {
        path: './Stats',
        routes: [
          {
            path: './Detail',
            component: '@/pages/opinion/pages/stats/Detail/index',
          },
          {
            path: './KeywordCorrelation',
            component: '@/pages/opinion/pages/keywordCorrelation/index',
          },
          {
            path: './Channel',
            component: '@/pages/opinion/pages/stats/channel/index',
          },
          {
            path: './Version',
            component: '@/pages/opinion/pages/stats/version/index',
          },
          {
            path: './Language',
            component: '@/pages/opinion/pages/stats/language/index',
          },
          {
            path: './Region',
            component: '@/pages/opinion/pages/stats/regionCountry/index',
          },
          {
            path: './Topic',
            component: '@/pages/opinion/pages/stats/topic/index',
          },
          {
            path: './Keyword',
            component: '@/pages/opinion/pages/stats/keyword/index',
          },
        ],
      },
      {
        path: './Feeds/Feeds',
        component: '@/pages/opinion/pages/feeds/index',
      },
      {
        path: './Feeds/Feeds/Details/:id',
        component: '@/pages/opinion/pages/feeds/Details/index',
      },
      {
        path: './trends',
        component: '@/pages/opinion/pages/trends/index',
      },
      {
        path: './Community',
        routes: [
          {
            path: './Streaming',
            component: '@/pages/opinion/pages/community/streaming',
          },
          {
            path: './Video',
            component: '@/pages/opinion/pages/community/video/index',
          },
          {
            path: './Hashtag',
            component: '@/pages/opinion/pages/community/hashtag/index',
          },
        ],
      },
      {
        path: './Influencer',
        routes: [
          {
            path: './BrandOverview',
            component: '@/pages/opinion/pages/Influencer/BrandOverview/index',
          },
          {
            path: './BrandCreatorList',
            component:
              '@/pages/opinion/pages/Influencer/BrandCreatorList/index',
          },
          {
            path: './GenreCreatorList',
            component:
              '@/pages/opinion/pages/Influencer/GenreCreatorList/index',
          },
        ],
      },
      {
        path: './Accounts',
        routes: [
          {
            path: './ByChannel/:tab?',
            component: '@/pages/opinion/pages/accounts/bychannel/index',
          },
          {
            path: './ByAccount/:tab?',
            component: '@/pages/opinion/pages/accounts/byaccount/index',
          },
        ],
      },
      {
        path: './DataMap',
        routes: [
          {
            path: './OpinionsSources',
            component: '@/pages/opinion/pages/dataMap/opinionsSources/index',
          },
          {
            path: './OpinionsMetrics',
            component: '@/pages/opinion/pages/dataMap/opinionsMetrics/index',
          },
          {
            path: './NewsCrawlers',
            component: '@/pages/opinion/pages/dataMap/newsCrawlers/index',
          },
          {
            path: './SentimentCriteria',
            component: '@/pages/opinion/pages/dataMap/sentimentCriteria/index',
          },
          {
            path: './ValidationCriteria',
            component: '@/pages/opinion/pages/dataMap/validationCriteria/index',
          },
          {
            path: './AISummaryDemo',
            component: '@/pages/opinion/pages/dataMap/GPTSummaryDemo/index',
          },
        ],
      },
      {
        path: './GameStore',
        component: '@/pages/opinion/pages/gamestore/index',
      },
      {
        path: './SteamPerformance',
        routes: [
          {
            path: '.',
            component:
              '@/pages/opinion/pages/SteamPerformance/SteamRatings/index',
          },
          {
            path: './SteamRatings',
            component:
              '@/pages/opinion/pages/SteamPerformance/SteamRatings/index',
          },
          {
            path: './RealtimeRatings',
            component:
              '@/pages/opinion/pages/SteamPerformance/RealtimeRatings/index',
          },
          {
            path: './Insights',
            component: '@/pages/opinion/pages/SteamPerformance/Insights/index',
          },
          {
            path: './VersionAnalysis',
            component:
              '@/pages/opinion/pages/SteamPerformance/VersionAnalysis/List/index',
          },
          {
            path: './VersionAnalysis/Details',
            component:
              '@/pages/opinion/pages/SteamPerformance/VersionAnalysis/Details/index',
          },
        ],
      },
      {
        path: './Competitor',
        component: '@/pages/opinion/pages/competitor/index',
      },
      {
        path: './Compare',
        routes: [
          {
            path: '.',
            component: '@/pages/opinion/pages/Compare/Compare/index',
          },
          {
            path: './Compare',
            component: '@/pages/opinion/pages/Compare/Compare/index',
          },
        ],
      },
      {
        path: './Detail',
        component: '@/pages/opinion/pages/Detail',
      },
      {
        path: './authPath/report/:reportId',
        component: '@/pages/opinion/pages/authPath/index',
      },
      {
        path: './Report/VoiceReportingTextAnalysis',
        component: '@/pages/opinion/pages/report/VoiceReportingTextAnalysis',
      },
      {
        path: './Report/:reportId',
        component: '@/pages/opinion/pages/report/report',
      },
      {
        path: './Looker/:lookerId',
        component: '@/pages/opinion/pages/report/looker',
      },
      {
        path: './Insights',
        component: '@/pages/opinion/pages/report/insight',
      },
      {
        path: './gpt/GPT Auto Report',
        component: '@/pages/opinion/pages/report/gpt',
      },
      {
        path: './gptReport/:menuId/:kind/:hasReportId',
        component: '@/pages/opinion/pages/report/gptReport',
      },
      {
        path: './Preset/:reportId',
        component: '@/pages/opinion/pages/report/preset',
      },
      {
        path: './PDFReport/:pdfId',
        component: '@/pages/opinion/pages/report/pdfReport',
      },
      {
        path: './AIGalleryReport/:reportId',
        component: '@/pages/opinion/pages/report/AIGalleryReport',
      },
      {
        path: './Hero',
        component: '@/pages/opinion/pages/Hero',
      },
      {
        path: './CustomizeReport/:name/:id',
        component: '@/pages/opinion/pages/report/CustomizeReport',
      },
      {
        path: './Realtime',
        routes: [
          {
            path: './RealtimeStreaming',
            component: '@/pages/opinion/pages/RealtimeStreaming/index',
          },
          {
            path: './RealtimeStreaming/Details/:id',
            component: '@/pages/opinion/pages/RealtimeStreaming/Details/index',
          },
        ],
      },
      {
        path: './Security-RelatedMentionsWeeklyReport',
        component: '@/pages/opinion/pages/SecurityWeeklyReport/index',
      },
      {
        path: './AdDeliveryOverview',
        routes: [
          {
            path: '.',
            component: '@/pages/opinion/pages/adCreatives/overview/index',
          },
        ],
      },
      {
        path: './CustomizedReports',
        routes: [
          {
            path: './WeeklyReport',
            routes: [
              {
                path: './Overview',
                component:
                  '@/pages/opinion/pages/CustomizedReports/WeeklyReport/Overview',
              },
              {
                path: './OfficialAccountsPerformance',
                component:
                  '@/pages/opinion/pages/CustomizedReports/WeeklyReport/OfficialAccountsPerformance',
              },
              {
                path: './VersionPerformance',
                component:
                  '@/pages/opinion/pages/CustomizedReports/WeeklyReport/VersionPerformance',
              },
              {
                path: './VersionPerformance/Configuration',
                component:
                  '@/pages/opinion/pages/CustomizedReports/WeeklyReport/Configuration',
              },
            ],
          },
          // {
          //   path: './QuarterlyReport',
          //   component: '',
          // },
          // {
          //   path: './VersionReprt',
          //   component: '',
          // }
        ],
      },
      {
        path: './',
        component: '@/pages/opinion/pages/Overview/KeyMetrics/index',
      },
      {
        path: './gamelist',
        component: '@/pages/opinion/pages/gamelist/index',
      },
      {
        path: './',
        routes: [
          {
            path: './noPermission',
            component: '@/pages/opinion/pages/noPermission/index',
          },
          {
            path: './Demo/Filter/DFFDDFFDFDFDFDDFDFDF',
            component: '@/pages/opinion/pages/Demo/Filter',
          },
          {
            path: './Demo/GPTPage',
            component: '@/pages/opinion/pages/Demo/GPT',
          },
          {
            path: './Demo/Format',
            component: '@/pages/opinion/pages/Demo/Format',
          },
          {
            path: './Lock/:id',
            component: '@/pages/opinion/pages/Lock/index',
          },
          {
            path: './Demo/EChart',
            component: '@/pages/opinion/pages/Demo/EChart',
          },
        ],
      },
    ],
  },
];
